import { SVGProps } from 'react';

export default function MapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M2 20.506C2 21.2612 2.40248 21.6845 3.09471 21.6845C3.3439 21.6845 3.58497 21.5998 3.90552 21.4111L7.94284 19.1038V2.1775C7.76897 2.25994 7.57867 2.36204 7.40271 2.47076L2.8395 5.2488C2.27582 5.58741 2 6.07099 2 6.75698V20.506ZM9.25595 18.907L14.1006 21.7914C14.2499 21.8849 14.3972 21.9523 14.5424 22V5.31801L9.79817 2.23271C9.63033 2.12397 9.44212 2.04133 9.25595 2V18.907ZM15.8576 21.9609C15.9518 21.9304 16.0583 21.8869 16.1465 21.8259L21.1503 18.8031C21.7241 18.4646 22 17.9701 22 17.2841V3.53509C22 2.77547 21.5852 2.35666 20.897 2.35666C20.6581 2.35666 20.4068 2.43911 20.0964 2.61701L15.8576 5.11663V21.9609Z" />
    </svg>
  );
}
